<template>
  <div class="appadd">
    <div class="mation_content">
      <Application streamer="创建应用"></Application>
      <div class="mation_right">
          <label class="z_name mc"><span>*</span>应用名称：</label>
          <input
            class="z_inp mp"
            type="text"
            v-model="form.app_name"
            disabled
          />

          <label class="z_name mc"><span>*</span>类型：</label>
          <select class="z_inp mp" v-model="form.ddtype" disabled>
            <option value="0">自用</option>
            <option value="1">第三方</option>
          </select>

          <label class="z_name mc" style="vertical-align: top;">应用描述：</label>
          <textarea
            class="z_inp mp"
            rows="5"
            cols="20"
            v-model="form.desc"
            disabled
          ></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import Application from "@/components/application.vue";
import { reactive,inject, onMounted } from 'vue';
import { useRoute } from 'vue-router';

export default {
  name: "AppAdd",
  setup() {
    const useAxios = inject("useAxios");
    const route = useRoute();
    const form = reactive({
      app_name:'',
      ddtype:0,
      desc:'',
    });
    onMounted(()=>{
      if(route.params.id){
        echoData();
      }
    })

    //回显数据
    function echoData(){
      useAxios.get(`/foreground/web/company/app/info?id=${route.params.id}`).then(res=>{
        if(res.data.code == 0 && res.data.attach){
          form.app_name = res.data.attach.appName;
          form.ddtype = res.data.attach.appType;
          form.desc = res.data.attach.appDesc;
        }
      })
    }
    return {
      form,
    }
  },
  components: {
    Application,
  },
};
</script>

<style lang="less" scoped>
.mation_content {
  width: 1200px;
  margin: 0px auto;
  border-top: none;
  overflow: hidden;
  margin-bottom: 74px;
  padding-bottom: 10px;
  .mation_right {
    width: 100%;
    height: auto;
    clear: both;
    text-align: left;
    .mc{
      width: 20%;
      box-sizing: border-box;
      display: inline-block;
    }
    .z_name{
      color: #000;
      font-size: 16px;
      margin-top: 25px;
      text-align: right;
      padding-right: 6px;
      font-family: "微软雅黑";
      outline: none;
      span{
        color: red;
        font-size: 16px;
      }
    }
    .mp{
      width: 29%;
      box-sizing: border-box;
    }
    .z_inp{
      height: 35px;
      border: 2px solid #000;
      border-radius: 6px;
      margin-top: 14px;
      padding-left: 6px;
    }
    .sty_box{
      width: 100%;
      clear: both;
      padding-top: 100px;
      text-align: center;
    }
  }
}
.el-button{
  padding: 12px 90px;
}
@media screen and (max-width: 1280px){
  .mation_content {
    width: 80%;
  }
}
@media screen and (max-width: 1200px){
  .mation_content {
      width: 90%;
  }
}
</style>